<template>
  <div class="template-list">
    <div class="add-btn">
      <el-button type="primary" size="medium" @click="add">新建模版</el-button>
      <!-- <PrintButton :templateList="templateList" /> -->
    </div>
    <div class="template-list-content">
      <div v-for="item in templateList" :key="item.id">
        <!-- templateType == 6 水洗标 -->
        <!-- <div class="template-list-item" v-if="item.templateType != 6"> -->
        <div class="template-list-item" >
          <div>{{ item.templateName || '未命名模板' }}</div>
          <div class="template-html" v-html="item.templateHtml"></div>
          <el-button type="primary" class="btn" @click="editTemplate(item)">编辑</el-button>
        </div>
      </div>
    </div>
    <AddTemplate ref="addTemplate" @submit="saveSubmit" :templateList="templateList" />
  </div>
</template>
<script>
import AddTemplate from "@/components/PrintTemplate/index.vue";
import PrintButton from "@/components/PrintTemplate/printButton.vue";
import { printList, savePrint } from "@/apis/configure";
import { hanlePrintElementsStyle } from "@/components/PrintTemplate/index.js";
export default {
  name: "ConfigureLabelTemplate",
  components: {
    AddTemplate,
    PrintButton,
  },
  data() {
    return {
      templateList: [],
    };
  },
  mounted() {
    this.getPrintList();
  },
  methods: {
    getPrintList() {
      printList().then(({ code, data }) => {
        if (code === 0) {
          this.templateList = data;
        }
      });
    },
    add() {
      this.$refs.addTemplate.dialogFormVisible = true;
      this.$nextTick((_) => {
        this.$refs.addTemplate.templateJson.printElements = [];
        $("#templateDesignDiv").html("");
        // this.$refs.addTemplate.draw();
        this.$refs.addTemplate.isEdit = false;
        this.$refs.addTemplate.templateName = "";
        this.$refs.addTemplate.templateType = 0;
      });
    },
    saveSubmit(payload) {
      console.log(payload);
      let params = {
        ...payload,
      };
      savePrint(payload).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.$refs.addTemplate.dialogFormVisible = false;
          this.getPrintList();
        }
      });
    },
    editTemplate(record) {
      let templateJson = JSON.parse(record.templateJson).panels[0]
        .printElements;
      this.$refs.addTemplate.dialogFormVisible = true;
      this.$nextTick((_) => {
        this.$refs.addTemplate.templateJson.printElements = templateJson;
        this.$refs.addTemplate.draw();
        this.$refs.addTemplate.isEdit = record;
        this.$refs.addTemplate.templateName = record.templateName;
        this.$refs.addTemplate.templateType = record.templateType;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.template-list {
  padding: 20px;
}

.add-btn {
  text-align: left;
}

.template-list-content {
  display: flex;
  flex-wrap: wrap;

  .template-list-item {
    margin: 20px 4px 20px 0;

    .template-html {
      border: 1px solid #f2f2f2;
    }

    .btn {
      width: 100%;
      margin-top: 10px;
    }
  }
}
</style>
